var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "category__block" },
    [
      _c("div", {
        staticClass: "category__name",
        class: _vm.nameClass,
        domProps: { textContent: _vm._s(_vm.i18n.reactions[_vm.type]) }
      }),
      _c(
        "div",
        {
          staticClass: "category__wrap-slider",
          class: { "is-active": _vm.active }
        },
        [
          _c("div", {
            staticClass: "category__close category__close--global icon-close3",
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.active = false
              }
            }
          }),
          _c(
            "slider",
            {
              staticClass: "category__slider",
              attrs: {
                options: {
                  prevButton: ".category__nav--prev",
                  nextButton: ".category__nav--next"
                }
              }
            },
            [
              _vm._l(_vm.items, function(item) {
                return _c(
                  "swiper-slide",
                  { key: item.product.id, staticClass: "category__slide" },
                  [
                    _c("div", {
                      staticClass:
                        "category__close category__close--desktop icon-close3",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.confirmOpen(item)
                        }
                      }
                    }),
                    _c("div", {
                      staticClass: "calendar__title",
                      domProps: { textContent: _vm._s(item.product.name) }
                    }),
                    _c("div", { staticClass: "calendar__img img" }, [
                      _c("img", {
                        staticStyle: { "max-height": "55px" },
                        attrs: { src: item.product.small_image },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.active = true
                          }
                        }
                      })
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "category__close category__close--mobile",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.confirmOpen(item)
                          }
                        }
                      },
                      [_vm._v("Удалить")]
                    )
                  ]
                )
              }),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.items.length > 0,
                    expression: "items.length > 0"
                  }
                ],
                staticClass: "category__nav category__nav--prev icon-left",
                attrs: { slot: "button-next" },
                slot: "button-next"
              }),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.items.length > 0,
                    expression: "items.length > 0"
                  }
                ],
                staticClass: "category__nav category__nav--next icon-right",
                attrs: { slot: "button-prev" },
                slot: "button-prev"
              })
            ],
            2
          )
        ],
        1
      ),
      _c(
        "custom-modal",
        {
          ref: "confirm",
          attrs: { title: _vm.confirmTitle, dismissible: false },
          on: {
            click: function($event) {
              $event.preventDefault()
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "modal__picture img" }, [
            _c("img", {
              attrs: {
                src: _vm.removable.large_image || _vm.removable.small_image
              }
            }),
            _c("div", { staticClass: "modal__icon", class: _vm.confirmIcon })
          ]),
          _c("template", { slot: "footer" }, [
            _c("div", { staticClass: "modal__part" }, [
              _c("button", {
                staticClass: "calendar__link modal__link2",
                domProps: { textContent: _vm._s(_vm.i18n.yes) },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.confirmSucceed()
                  }
                }
              }),
              _c("button", {
                staticClass: "calendar__link modal__link2",
                domProps: { textContent: _vm._s(_vm.i18n.no) },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.confirmClose()
                  }
                }
              })
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b6243d60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6243d60","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/calendar/components/reaction-slider.vue
// module id = 245
// module chunks = 4